import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "none_selected",
  "use": "none_selected-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"none_selected\"><path d=\"M8 .5C3.86.5.5 3.86.5 8s3.36 7.5 7.5 7.5 7.5-3.36 7.5-7.5S12.14.5 8 .5M2 8c0-3.31 2.69-6 6-6 1.39 0 2.66.47 3.67 1.26l-8.41 8.41A5.93 5.93 0 0 1 2 8m6 6c-1.39 0-2.66-.47-3.67-1.26l8.41-8.41A5.93 5.93 0 0 1 14 8c0 3.31-2.69 6-6 6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol